import { createSelector } from 'reselect';
import get from 'lodash/get';
import { isNumeric, isNonEmptyString } from '../../js/app/react/validators';

const stateSelector = state => state;
const workflowIDSelector = (_, { workflowId }) => workflowId;

export const nullableCurrentClientIdSelector = createSelector(
  stateSelector,
  workflowIDSelector,
  (state, workflowID) => get(state, `AdvWorkflow[${workflowID}].currentClientId`, null),
);

export const educationGoalsSelector = createSelector(
  stateSelector,
  workflowIDSelector,
  nullableCurrentClientIdSelector,
  (state, workflowID, clientId) => {
    if (!isNumeric(clientId)) {
      throw new Error('clientID must be set at this point');
    }
    if (!isNonEmptyString(workflowID)) {
      throw new Error('workflowID must be set at this point');
    }
    return get(state, `AdvWorkflow[${workflowID}][${clientId}].data.EducationGoals`, []);
  },
);

export const largePurchaseGoalsSelector = createSelector(
  stateSelector,
  workflowIDSelector,
  nullableCurrentClientIdSelector,
  (state, workflowID, clientId) => {
    if (!isNumeric(clientId)) {
      throw new Error('clientID must be set at this point');
    }
    if (!isNonEmptyString(workflowID)) {
      throw new Error('workflowID must be set at this point');
    }
    return get(state, `AdvWorkflow[${workflowID}][${clientId}].data.LargePurchaseGoals`, []);
  },
);

export const homePurchaseGoalsSelector = createSelector(
  stateSelector,
  workflowIDSelector,
  nullableCurrentClientIdSelector,
  (state, workflowID, clientId) => {
    if (!isNumeric(clientId)) {
      throw new Error('clientID must be set at this point');
    }
    if (!isNonEmptyString(workflowID)) {
      throw new Error('workflowID must be set at this point');
    }
    return get(state, `AdvWorkflow[${workflowID}][${clientId}].data.HomePurchaseGoals`, []);
  },
);
